import React, { FC, ReactNode } from 'react';
import { Skeleton } from '@mui/material';

type SkeletonRowProps = {
    label: ReactNode;
    amount?: ReactNode;
    isLoading: boolean;
};

const SkeletonRow: FC<SkeletonRowProps> = ({ label, amount, isLoading }) => {
    return (
        <div className="row w-100" >
            <div className="col-8">
                {isLoading ? (
                    <Skeleton variant="text" width={100} height={20} />
                ) : (
                    label
                )}
            </div>
            {amount && <div className="col-4 row " style={{ justifyContent: 'right' }}>
                {isLoading ? (
                    <Skeleton variant="text" width={80} height={20} />
                ) : (
                    amount
                )}
            </div>
            }
        </div>
    );
};

export default SkeletonRow;